module.exports = __webpack_public_path__ + "static/img/2.7ddb389.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/2.png
// module id = 5inV
// module chunks = 0